import styles from '../player.module.scss';
import Icona from '../../../../components/3catinfo/ui/Icona';
import CodiEspectador from '../../../../components/3catinfo/CodiEspectador';
import __isEmpty from 'lodash/isEmpty';

export default function FullScreen(props) {
    const { titol, nomProg, textAud, changeAudioDesc, aud, edat } = props;
    const codiEdat = edat?.replace('CE_', '').replace(/^0+/, '');
    const altEdat = codiEdat && !isNaN(codiEdat) ? `${codiEdat} anys` : '';

    return (
        <div className={styles.fullscreenrow}>
            <div className={styles.nom}>{nomProg}</div>
            <div className={styles.titol}>{titol}</div>
            <div className={styles.subinfo}>
                {edat !== 'CE_DA' && !__isEmpty(edat) && (
                    <span className={styles.edat}>
                        <CodiEspectador codi={edat} alt={altEdat} mida='20' />
                    </span>
                )}
                {aud && (
                    <button className={styles.boto} aria-label='audiodescripció' onClick={changeAudioDesc}>
                        <div className={styles.boto_text}>{textAud}</div>
                        <Icona estil='clickable' alt='Audiodescripció' icona='audiodescripcio' />
                    </button>
                )}
            </div>
        </div>
    );
}
